import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useEstabelecimento } from '../../hooks/useEstabelecimento';
import { TipoUsuario } from '../../types';
import {
  BarChart3,
  ShoppingCart,
  Cookie,
  Package,
  ClipboardList,
  Users,
  UserCog,
  TrendingUp,
  DollarSign,
} from 'lucide-react';

interface SidebarProps {
  isOpen: boolean;
  onClose: () => void;
}

const Sidebar: React.FC<SidebarProps> = ({ isOpen, onClose }) => {
  const location = useLocation();
  const { user } = useAuth();
  const { data: estabelecimento, isLoading } = useEstabelecimento(user?.estabelecimentoId);

  const isFuncionario = user?.tipo === TipoUsuario.FuncionarioEstabelecimento;

  const allMenuItems = [
    { path: '/dashboard', label: 'Dashboard', icon: BarChart3 },
    { path: '/pdv', label: 'PDV', icon: ShoppingCart },
    { path: '/produtos', label: 'Produtos', icon: Cookie },
    { path: '/estoque', label: 'Estoque', icon: Package },
    { path: '/encomendas', label: 'Encomendas', icon: ClipboardList },
    { path: '/clientes', label: 'Clientes', icon: Users },
    { path: '/funcionarios', label: 'Funcionários', icon: UserCog },
    { path: '/relatorios', label: 'Relatórios', icon: TrendingUp },
    { path: '/fechamento-caixa', label: 'Fechamento de Caixa', icon: DollarSign },
  ];

  const menuItems = isFuncionario
    ? allMenuItems.filter((item) => item.path === '/pdv')
    : allMenuItems;

  return (
    <div
      className={`h-full bg-neutral-900 text-white w-64 fixed left-0 top-0 overflow-y-auto z-40 transform transition-transform duration-300 ease-in-out border-r border-neutral-800 ${
        isOpen ? 'translate-x-0' : '-translate-x-full'
      } lg:translate-x-0`}
    >
      {/* Bot\u00e3o de fechar para mobile */}
      <button
        onClick={onClose}
        className="lg:hidden absolute top-4 right-4 text-white text-3xl hover:text-neutral-300 w-8 h-8 flex items-center justify-center"
        aria-label="Fechar menu"
      >
        ×
      </button>

      <div className="px-6 py-5 border-b border-neutral-800">
        <img src="/logo.png" alt="Gestta" className="h-7 brightness-0 invert" />
        {estabelecimento?.nome && !isLoading && (
          <p className="text-xs text-neutral-500 mt-2 truncate pr-8 lg:pr-0">{estabelecimento.nome}</p>
        )}
      </div>

      <nav className="p-4">
        <ul className="space-y-3">
          {menuItems.map((item) => {
            const IconComponent = item.icon;
            return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  onClick={() => {
                    if (window.innerWidth < 1024) onClose();
                  }}
                  className={`flex items-center gap-3 px-4 py-3 rounded-lg transition-all duration-200 ${
                    location.pathname === item.path || location.pathname.startsWith(item.path + '/')
                      ? 'bg-gradient-to-r from-primary-500 to-primary-600 text-white shadow-md border-l-4 border-primary-300'
                      : 'text-neutral-400 hover:bg-neutral-800 hover:text-neutral-200 hover:scale-[1.02]'
                  }`}
                >
                  <IconComponent className="w-5 h-5" />
                  <span className="font-medium">{item.label}</span>
                </Link>
              </li>
            );
          })}
        </ul>
      </nav>
    </div>
  );
};

export default Sidebar;
